<template>
    <div class="my-6" v-for="(child, index) in taskData?.children" :key="index">
        <ComponentProvider :data="child" @formModEvent="emitChildEvent" :result="results[child.name]">
        </ComponentProvider>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import ComponentProvider from './formComponents/ComponentProvider.vue'

export default defineComponent({
    name: 'FormComponent',
    components: {
        ComponentProvider,
    },
    props: {
        taskData: Object,
        results: Object,
    },
    emits: ['formModEvent'],
    data() {
        return {
            selectedTask: null,
        }
    },
    methods: {
        emitChildEvent(data) {
            this.$emit('formModEvent', data);
        }
    }
})
</script>
